<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h4>As Required Reports Schedule for</h4>
    </div>
    <div class="col-xs-12 col-md-6  vcenter-right">
      <div>
        Month:
          <mat-form-field appearance="fill" >
            <mat-select name="Month" (valueChange)="monthChange($event)"
                                   [value]="month | async" >
              <mat-option *ngFor="let m of months" [value]="m.number">
                {{ m.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <span style="margin-left: 10px">Year: </span>
          <mat-form-field appearance="fill" >
            <mat-select name="Year" (valueChange)="yearChange($event)"
                                   [value]="year | async" >
              <mat-option *ngFor="let y of years" [value]="y">
                {{ y }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:2px" />

  <div class="row top10">
    <form novalidate #myForm="ngForm">
    <aims-common-table
        id="report-sched-table"
        [dataSource]="asRequiredReportSchedule |async"
        [header]="tableHeader"
        [permissions]="tablePermissions"
        pageSize="20"
        [addRowInitialObject]="defaultRow"
        (rowUpdated)="handleRowUpdate($event)"
        (rowDeleted)="handleRowDelete($event)"
        (rowAdded)="handleRowAdded($event)"
        [exportFunction]="getForExcel"
        [stickyHeader]="true">

        <ng-template aimsCommonTableDynamicToolbar *ngIf="!(asRequiredReportSchedule === undefined || asRequiredReportSchedule == null)">
          <aims-common-button aria-label="Print" [routerLink]="printReportName" >
            <mat-icon>print</mat-icon>
            Print
          </aims-common-button>
        </ng-template>

        <aims-common-table-dynamic-row id="reportScheduleId">
          <ng-template viewMode let-element let-idx="idx">
            {{ element.reportScheduleId | getText:'reportScheduleId':'reportScheduleNumber': asReqReportScheduleValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
            <aims-lookup
              [formControl]="dynamicControl"
              name="reportScheduleNumber"
              id="reportScheduleNumber"
              class="fullWidth"
              [gridText]="'Select a Report Schedule'"
              [values]="asReqReportScheduleValues | async"
              [idPropertyName]="'reportScheduleId'"
              [displayPropertyName]="'reportScheduleNumber'"
              [columnsInGrid]="reportScheduleLookupColumns"
              [disabled]="!canAdd()"
              required>
            </aims-lookup>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="siteId">
          <ng-template viewMode let-element >
            {{ element.siteId | getText:'siteId':'siteCode':siteValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
            <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <mat-select style="width: 100px" [formControl]="dynamicControl" name="siteId">
                <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                  {{ s.siteCode }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter" name="siteFilter">
                <mat-option *ngFor="let s of siteValues | async" [value]="s.siteId">
                  {{ s.siteCode }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="inspectionSequenceId">
          <ng-template viewMode let-element >
            {{ element.inspectionSequenceId | getText:'inspectionSequenceId':'inspectionSequence':inspectionSequenceValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
            <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <mat-select style="width: 100px" [formControl]="dynamicControl" name="inspectionSequenceId" required>
                <mat-option *ngFor="let i of inspectionSequenceValues | async " [value]="i.inspectionSequenceId">
                  {{ i.inspectionSequence }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter" name="sequenceFilter">
                <mat-option *ngFor="let i of inspectionSequenceValues | async " [value]="i.inspectionSequenceId">
                  {{ i.inspectionSequence }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

      </aims-common-table>

    </form>
    <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

  </div>

</div>
